import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../Types/UserTypeInterface";

interface UserTypeState {
    userTypes: UserType[];
    loading: boolean;
    error: string | null;
    selectedUserType: UserType | null;
}

const initialState: UserTypeState = {
    userTypes: [],
    loading: false,
    error: null,
    selectedUserType : null
}

const userTypeSlice = createSlice ({
    name: 'userTypes',
    initialState,
    reducers: {
        fetchUserTypesStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchUserTypesSuccess: (state, action: PayloadAction<UserType[]>) => {
            state.loading = false;
            state.userTypes = action.payload;
            state.selectedUserType = null;
        },
        fetchUserTypesFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        setSelectUserType : (state, action: PayloadAction<UserType | null>) => {
            state.selectedUserType = action.payload;
        }
    }
});

export const { fetchUserTypesStart, fetchUserTypesSuccess, fetchUserTypesFailure, setSelectUserType } = userTypeSlice.actions;
export default userTypeSlice.reducer;